<a
  class="main-button"
  (click)="onButtonClick()"
  [ngClass]="{'disabled': disabled}"
  [style.font-size]="fontSize"
  [style.border]="border"
  [style.height]="buttonHeight"
  [style.width]="buttonWidth"
  [style.color]="textColor"
  [style.max-width]="maxWidth"
  [style.font-weight]="fontWeight"
  [style.text-decoration]="textDecoration"
  [style.background-color]="backgroundColor">
  <span>
    {{buttonText}}
  </span>
</a>
